import { render, staticRenderFns } from "./TransferResponsibility.vue?vue&type=template&id=6ae2a9fc&scoped=true&"
import script from "./TransferResponsibility.vue?vue&type=script&lang=js&"
export * from "./TransferResponsibility.vue?vue&type=script&lang=js&"
import style0 from "./TransferResponsibility.vue?vue&type=style&index=0&id=6ae2a9fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae2a9fc",
  null
  
)

export default component.exports